import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setSalesPrice } from '../../redux/modules/salestaxes';

class SalesPrice extends Component {
  constructor(props) {
    super(props);
    this.onEnterText = this.onEnterText.bind(this);
  }

  onEnterText(event) {
    const value = event.target.value;
    this.props.setSalesPrice(value);
  }

  render() {
    const { salesPrice } = this.props;
    return (
      <div className="Row Title-feeRow">

        <input
          id="Price"
          data-id="totalSalesPrice"
          data-tooltip="Enter vehicle purchase price less any trade-in value allowed. Note that discounts may be deducted from taxable price, however rebate amounts are taxable and must be included. Some transactions may be exempt from sales and use tax.\n Sales tax is not due when titling a leased vehicle if a sales tax registration number is provided.\n To calculate the correct discretionary tax the Price for a double or triple-wide mobile home should be the total for all units added together."
          type="number"
          value={salesPrice}
          onChange={this.onEnterText}
          className="Row-total Row-editableTotal"
        />

        <b className="no-print">Enter Total Sales Price</b>
        <b className="print-label print-only">Total Sales Price</b>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    salesPrice: state.salestaxes.salesPrice,
  };
};

export default connect(mapStateToProps, { setSalesPrice })(SalesPrice);



// WEBPACK FOOTER //
// ./src/containers/salestaxes/SalesPrice.js